import { OrchestrationEditForm } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/OrchestrationEditForm';
import { MerchantOrchestrationMap } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/maps/merchantOrchestration.map';
import {
  fromOrchestrationConfig,
  OrchestrationFormSchema,
} from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/schemas/orchestrationForm.schema';
import { OrchestrationEditProps } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/OrchestrationEditProps';
import { FormWrapper } from '@/components/shared/components/FormWrapper';

export const OrchestrationEditPanel = (props: OrchestrationEditProps) => (
  <FormWrapper
    formSchema={OrchestrationFormSchema}
    defaultValues={fromOrchestrationConfig(MerchantOrchestrationMap.majorityConfig(props.row))}
  >
    <OrchestrationEditForm {...props} />
  </FormWrapper>
);
